calculator = window.calculator || {};
calculator.init = function () {};
